import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";

const GraphComponent = ({ selectedChartData }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    console.log(selectedChartData);
    if (chartRef.current) {
      if (chartInstance.current) {
        chartInstance.current.destroy(); // Destroy the existing chart instance
      }

      const ctx = chartRef.current.getContext("2d");
      // chartRef.current.width = 40;
      // chartRef.current.height = 30;
      chartInstance.current = new Chart(ctx, {
        type: "line",
        data: {
          labels: selectedChartData.map((item) => item._id),
          datasets: [
            {
              label: "Counts",
              data: selectedChartData.map((item) => item.count),
              borderColor: "rgba(75, 192, 192, 1)",
              backgroundColor: "rgba(75, 192, 192, 0.2)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
    }
  }, [selectedChartData]);

  return <canvas ref={chartRef} />;
};

export default GraphComponent;
